// src/components/Navbar.jsx
import React, { useState, useEffect, useRef } from "react";
import ReactDOM from 'react-dom';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../App";
import logo from '../../upload/logo-2.jpg';
import "./navbar.css";
import home from '../../upload/home.jpg';
import homeMobile from '../../upload/menu-mobile/home.png';
import homeMobileActive from '../../upload/menu-mobile/home-active.png';
import lessonMobile from '../../upload/menu-mobile/lesson.png';
import lessonMobileActive from '../../upload/menu-mobile/lesson-active.png';
import profileMobile from '../../upload/menu-mobile/profile.png';
import profileMobileActive from '../../upload/menu-mobile/profile-active.png';
import homeDes from "../../upload/home.png";
import homeDesActive from "../../upload/home-active.png";
import lessonDes from "../../upload/lessons.png";
import lessonDesActive from "../../upload/lessons-active.png";
import classesDes from "../../upload/classes.png";
import classedDesActive from "../../upload/classes-active.png";
import profileDes from "../../upload/profile.png";
import profileDesActive from "../../upload/profile-active.png";
import notifiDes from "../../upload/notifi.png";
import notifiDesActive from "../../upload/notifi-active.png";
import settingDes from "../../upload/setting.png";
import settingDesActive from "../../upload/setting-active.png";
import trainingDes from "../../upload/training.png";
import trainingDesActive from "../../upload/training-active.png";
import helpDes from "../../upload/help.png";
import helpDesActive from "../../upload/help-active.png";
import logoutDes from "../../upload/logout.png";

export default function Navbar() {
  const { user, logout } = useAuth();
  const apiUrl = (process.env.REACT_APP_API_URL);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // listen for pending signals from other tabs and fetch pending count
  useEffect(() => {
    async function fetchPendingCount() {
      try {
        const apiUrl = (process.env.REACT_APP_API_URL);
        const token = localStorage.getItem('token');
        if (!apiUrl || !token) return;
        const res = await fetch(`${apiUrl}/api/posts/pending`, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) return;
        const d = await res.json();
        if (d && Array.isArray(d.posts)) setPendingCount(d.posts.length);
      } catch (e) { }
    }
    fetchPendingCount();
    let storageTimer = null;
    function onStorage(e) {
      if (!e) return;
      if (e.key === 'wolad_pending_signal') {
        if (storageTimer) clearTimeout(storageTimer);
        storageTimer = setTimeout(() => { fetchPendingCount().catch(() => { }); storageTimer = null; }, 400);
      }
    }
    window.addEventListener('storage', onStorage);
    return () => { window.removeEventListener('storage', onStorage); if (storageTimer) clearTimeout(storageTimer); };
  }, []);

  // keep notification dot updated in real-time using Server-Sent Events (no frequent polling)
  useEffect(() => {
    if (!user || !(user.role === 'Mod' || user.role === 'Teacher')) return;
    if (!apiUrl) return;
    const token = localStorage.getItem('token');
    if (!token) return;

    let es = null;
    let reconnectTimer = null;

    const connect = () => {
      try {
        const url = `${apiUrl.replace(/\/$/, '')}/api/notifications/stream?token=${encodeURIComponent(token)}`;
        es = new EventSource(url);
      } catch (e) {
        // fallback to single fetch if EventSource construction fails
        es = null;
      }
      if (!es) {
        // fallback: do a single fetch (no polling) to initialise state
        (async () => {
          try {
            const res = await fetch(`${apiUrl}/api/notifications`, { headers: { Authorization: `Bearer ${token}` } });
            if (!res.ok) return;
            const data = await res.json();
            const notes = data.notifications || [];
            const unread = notes.filter(n => !((n.read === true) || (n.isRead === true) || Boolean(n.readAt))).length;
            setHasUnreadNotifications(unread > 0);
          } catch (e) { }
        })();
        return;
      }

      es.addEventListener('notification:init', (ev) => {
        try { const d = JSON.parse(ev.data || '{}'); setHasUnreadNotifications(Boolean(d.unreadCount && d.unreadCount > 0)); } catch (e) { }
      });
      es.addEventListener('notification:new', (ev) => {
        try { const d = JSON.parse(ev.data || '{}'); setHasUnreadNotifications(Boolean(d.unreadCount && d.unreadCount > 0)); } catch (e) { }
      });
      es.addEventListener('notification:read', (ev) => {
        try { const d = JSON.parse(ev.data || '{}'); setHasUnreadNotifications(Boolean(d.unreadCount && d.unreadCount > 0)); } catch (e) { }
      });
      es.onopen = () => { /* connected */ };
      es.onerror = () => {
        try { es.close(); } catch (e) { }
        // try reconnect after a short delay (only on error)
        if (reconnectTimer) clearTimeout(reconnectTimer);
        reconnectTimer = setTimeout(() => { connect(); }, 5000);
      };
    };

    connect();

    return () => {
      try { if (es) es.close(); } catch (e) { }
      if (reconnectTimer) clearTimeout(reconnectTimer);
    };
  }, [apiUrl, user]);
  if (!user) return null;
  // show admin-style menu for Mods only when they are visiting the /admin area
  const inAdminArea = location && typeof location.pathname === 'string' && location.pathname.startsWith('/admin');
  const logoLink = user && user.role === 'Admin' ? '/admin' : '/';

  const menuItems = (
    <>
      {/* Admin: full admin menu. Mod: admin menu only when in /admin area. Others: normal menu */}
      {user && user.role === 'Admin' ? (
        <>
          <li><NavLink to="/admin" end>
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? notifiDesActive : notifiDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Dashboard</span>
              </span>
            )}
          </NavLink></li>
          <li><NavLink to="/admin/accounts">
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? profileDesActive : profileDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Accounts Management</span>
              </span>)}
          </NavLink></li>
          <li><NavLink to="/admin/lessons">
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? lessonDesActive : lessonDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Lessons Management</span></span>
            )}
          </NavLink></li>
          {/* <li><NavLink to="/admin/school-years">
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? settingDesActive : settingDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Schools & Years</span>
              </span>
            )}
          </NavLink></li>
          <li><NavLink to="/admin/history">
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? notifiDesActive : notifiDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>History</span>
              </span>
            )}
          </NavLink></li> */}
          <li>
            <a
              className="logout-text"
              onClick={() => setShowConfirm(true)}
            >
              <span className="nav-item-content">
                <img
                  src={logoutDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Logout</span>
              </span>
            </a>
            {showConfirm && ReactDOM.createPortal(
              <div className="confirm-modal" onClick={() => setShowConfirm(false)}>
                <div className="confirm-box" onClick={(e) => e.stopPropagation()}>
                  <p>Are you sure you want to logout?</p>
                  <div className="confirm-actions">
                    <button className="btn cancel" onClick={() => setShowConfirm(false)}>Cancel</button>
                    <button
                      className="btn confirm"
                      onClick={() => {
                        logout();
                        setShowConfirm(false);
                        try { navigate('/login'); } catch (e) { /* ignore */ }
                      }}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>,
              document.body
            )}
          </li>
        </>
      ) : (user && user.role === 'Mod' && inAdminArea) ? (
        <><li><NavLink to="/admin/accounts">
          {({ isActive }) => (
            <span className="nav-item-content">
              <img
                src={isActive ? profileDesActive : profileDes}
                alt="icon"
                width={20}
                height={20} />
              <span>Accounts Management</span>
            </span>)}
        </NavLink></li><li>
            <a
              className="logout-text"
              onClick={() => setShowConfirm(true)}
            >
              <span className="nav-item-content">
                <img
                  src={logoutDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Logout</span>
              </span>
            </a>
            {showConfirm && ReactDOM.createPortal(
              <div className="confirm-modal" onClick={() => setShowConfirm(false)}>
                <div className="confirm-box" onClick={(e) => e.stopPropagation()}>
                  <p>Are you sure you want to logout?</p>
                  <div className="confirm-actions">
                    <button className="btn cancel" onClick={() => setShowConfirm(false)}>Cancel</button>
                    <button
                      className="btn confirm"
                      onClick={() => {
                        logout();
                        setShowConfirm(false);
                        try { navigate('/login'); } catch (e) { /* ignore */ }
                      }}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>,
              document.body
            )}
          </li></>
      ) : (
        <>
          <li>
            <NavLink to="/">
              {({ isActive }) => (
                <span className="nav-item-content">
                  <img
                    src={isActive ? homeDesActive : homeDes}
                    alt="icon"
                    width={20}
                    height={20} />
                  <span>Home</span>
                </span>
              )}
            </NavLink>
          </li>
          <li><NavLink to="/lessons">
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? lessonDesActive : lessonDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Lessons</span></span>
            )}
          </NavLink></li>
          <li>
            <NavLink to="/classes">
              {({ isActive }) => (
                <span className="nav-item-content">

                  <img
                    src={isActive ? classedDesActive : classesDes}
                    alt="icon"
                    width={20}
                    height={20} />
                  <span>My Classes</span></span>
              )}
            </NavLink>
          </li>
          <li><NavLink to="/notifications">
            {({ isActive }) => (
              <span className={"nav-item-content nav-item-with-dot"}>

                <img
                  src={isActive ? notifiDesActive : notifiDes}
                  alt="icon"
                  width={20}
                  height={20} />
                {/* show small red dot for Mod or Teacher when there are unread notifications */}
                {((user && (user.role === 'Mod' || user.role === 'Teacher')) && hasUnreadNotifications) ? (
                  <span className="menu-notif-dot" aria-hidden="true"></span>
                ) : null}
                <span>Notifications</span>
              </span>
            )}
          </NavLink></li>
          <hr className="hr-menu mg-t-40" />
          <li><NavLink to="/profile">
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? profileDesActive : profileDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Profile</span>
              </span>)}
          </NavLink></li>
          <li><NavLink to="/settings">
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? settingDesActive : settingDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Settings</span>
              </span>)}
          </NavLink></li>
          <hr className="hr-menu" />
          <li><NavLink to="/training">
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? trainingDesActive : trainingDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Training</span>
              </span>)}
          </NavLink></li>
          <li><NavLink to="/help">
            {({ isActive }) => (
              <span className="nav-item-content">
                <img
                  src={isActive ? helpDesActive : helpDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Help</span>
              </span>)}
          </NavLink></li>
          <li>
            <a
              className="logout-text"
              onClick={() => setShowConfirm(true)}
            >
              <span className="nav-item-content">
                <img
                  src={logoutDes}
                  alt="icon"
                  width={20}
                  height={20} />
                <span>Logout</span>
              </span>
            </a>
            {showConfirm && ReactDOM.createPortal(
              <div className="confirm-modal" onClick={() => setShowConfirm(false)}>
                <div className="confirm-box" onClick={(e) => e.stopPropagation()}>
                  <p>Are you sure you want to logout?</p>
                  <div className="confirm-actions">
                    <button className="btn cancel" onClick={() => setShowConfirm(false)}>Cancel</button>
                    <button
                      className="btn confirm"
                      onClick={() => {
                        logout();
                        setShowConfirm(false);
                        try { navigate('/login'); } catch (e) { /* ignore */ }
                      }}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>,
              document.body
            )}
          </li>
        </>
      )}
    </>
  );
  // helper to resolve avatar urls (relative -> apiUrl)
  function resolveAvatarUrl(src) {
    const s = String(src || '');
    if (!s) return (apiUrl ? apiUrl.replace(/\/$/, '') + '/uploads/avt/avt-def.jpg' : '/uploads/avt/avt-def.jpg');
    if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('//')) return s;
    if (s.startsWith('/')) return (apiUrl ? apiUrl.replace(/\/$/, '') : '') + s;
    return (apiUrl ? apiUrl.replace(/\/$/, '') + '/' + s.replace(/^\//, '') : s);
  }

  return (
    <>

      {/* Desktop sidebar */}
      <div className="sidebar">
        <div className="top">
          <h2 className="logo"><Link to={logoLink}><img src={logo} height={90} width={220} alt="logo-wolad" /></Link></h2>
        </div>
        <hr />
        <div className="center">
          <ul className="menu">
            {menuItems}
          </ul>
        </div>
      </div>

      {/* Mobile bottom navigation (pill) */}
      <nav className="mobile-bottom-nav" role="navigation" aria-label="Mobile bottom navigation">
        <div className="mbn-pill">
          <NavLink to="/lessons" className="mbn-item" title="Lessons">
            {({ isActive }) => (
              <img
                src={isActive ? lessonMobileActive : lessonMobile}
                alt="icon"
                width={24}
                height={24}
              />
            )}
          </NavLink>
          <NavLink to="/" className="mbn-item mbn-center" title="Home">
            {({ isActive }) => (
              <img
                src={isActive ? homeMobileActive : homeMobile}
                alt="icon"
                width={24}
                height={24}
              />
            )}
          </NavLink>
          <NavLink to="/profile" className="mbn-item" title="Profile">
            {({ isActive }) => (
              <img
                src={isActive ? profileMobileActive : profileMobile}
                alt="icon"
                width={24}
                height={24}
              />
            )}
          </NavLink>
        </div>
      </nav>

    </>
  );
}
